/* include
------------------------------------------------------- */

import "core-js/stable";
import "regenerator-runtime/runtime";
import './scss/style.scss';

/*
------------------------------------------------------- */
gsap.registerPlugin('ScrollTrigger');

window.onload = function () {
  gsap.to(".js_mvbg", {
    y: -200,
    scrollTrigger: {
      toggleActions: "play none none reverse",
      end: "bottom 0%",
      trigger: ".ly_philosophy",
      start: "top 90%",
      scrub: true,
      //pin: true,
    },
  });

  const tl1 = gsap.to(".ly_philosophy__wrap", {
    borderRadius: "0%",
    width: "100vw",
    scrollTrigger: {
      toggleActions: "play none none reverse",
      end: "bottom 20%",
      trigger: ".ly_philosophy",
      start: "top 60%",
      scrub: true,
      anticipatePin: 1,
    },
  });
  tl1.scrollTrigger.refresh();

/*if (window.matchMedia("(max-width: 767px)").matches) {
  const tl2 = gsap.to(".js_scroll", {
    x: -250,
    scrollTrigger: {
      toggleActions: "play none none reverse",
      end: "bottom 0%",
      trigger: ".ly_overview__wrap__bottom",
      start: "top 100%",
      scrub: true,
    },
  });
  tl2.scrollTrigger.refresh();
} else if (window.matchMedia("(min-width:768px)").matches) {
  const tl2 = gsap.to(".js_scroll", {
    x: -160,
    scrollTrigger: {
      toggleActions: "play none none reverse",
      end: "bottom 30%",
      trigger: ".ly_overview__wrap__bottom",
      start: "top 100%",
      scrub: true,
    },
  });
  tl2.scrollTrigger.refresh();
}*/

/*$(window).on("load resize", function () {
  let w = $(window).width();
  if (w <= 768) {
  const tl2 = gsap.to(".js_scroll", {
    x: -250,
    scrollTrigger: {
      toggleActions: "play none none reverse",
      end: "bottom 0%",
      trigger: ".ly_overview__wrap__bottom",
      start: "top 100%",
      scrub: true,
    },
  });
  tl2.scrollTrigger.refresh();
  } else {
  const tl2 = gsap.to(".js_scroll", {
    x: -160,
    scrollTrigger: {
      toggleActions: "play none none reverse",
      end: "bottom 30%",
      trigger: ".ly_overview__wrap__bottom",
      start: "top 100%",
      scrub: true,
    },
  });
  tl2.scrollTrigger.refresh();
  }
});*/

  /*const tl3 = gsap.to(".js_pin__workA", {
    scrollTrigger: {
      toggleActions: "none play none none",
      end: "center +=70%",
      trigger: ".ly_workDetails",
      start: "top 50%",
      onLeave: () => $(".js_pin__workA").addClass("active"),
      onEnterBack: () => $(".js_pin__workA").removeClass("active"),
    },
  });
  tl3.scrollTrigger.refresh();

  const tl4 = gsap.to(".js_pin__workB", {
    scrollTrigger: {
      toggleActions: "none play none none",
      end: "bottom center+=25%",
      trigger: ".ly_workDetails",
      start: "top 50%",
      onLeave: () => $(".js_pin__workB,.ly_workDetails").addClass("active"),
      onEnterBack: () =>
        $(".js_pin__workB,.ly_workDetails").removeClass("active"),
    },
  });
  tl4.scrollTrigger.refresh();*/

if (window.matchMedia("(max-width: 767px)").matches) {
  //スマホ処理
  /*const tl5 = gsap.to(".ly_workDetails__wrap", {
    scrollTrigger: {
      toggleActions: "none play none none",
      start: "top 5%",
      end: "bottom 50%",
      trigger: ".ly_workDetails",
      onLeaveBack: () => $(".pin-spacer").removeClass("scroll"),
      onLeave: () => $(".ly_workDetails__wrap,.pin-spacer").addClass("scroll"),
      onEnterBack: () => $(".ly_workDetails__wrap").removeClass("scroll"),
    },
  });
  tl5.scrollTrigger.refresh();*/
} else if (window.matchMedia("(min-width:768px)").matches) {
  //PC処理
  /*const tl5 = gsap.to(".ly_workDetails__wrap", {
    scrollTrigger: {
      toggleActions: "none play none none",
      start: "top 0%",
      end: "bottom 50%",
      trigger: ".ly_workDetails",
      pin: true,
      anticipatePin: 1,
      onLeaveBack: () => $(".pin-spacer").removeClass("scroll"),
      onLeave: () => $(".ly_workDetails__wrap,.pin-spacer").addClass("scroll"),
      onEnterBack: () => $(".ly_workDetails__wrap").removeClass("scroll"),
    },
  });
  tl5.scrollTrigger.refresh();*/
}

/*$(window).on("load", function () {
  let w = $(window).width();
  if (w <= 768) {
  const tl5 = gsap.to(".ly_workDetails__wrap", {
    scrollTrigger: {
      toggleActions: "none play none none",
      start: "top 5%",
      end: "bottom 50%",
      trigger: ".ly_workDetails",
      onLeaveBack: () => $(".pin-spacer").removeClass("scroll"),
      onLeave: () => $(".ly_workDetails__wrap,.pin-spacer").addClass("scroll"),
      onEnterBack: () => $(".ly_workDetails__wrap").removeClass("scroll"),
    },
  });
  tl5.scrollTrigger.refresh();
  } else {
  const tl5 = gsap.to(".ly_workDetails__wrap", {
    scrollTrigger: {
      toggleActions: "none play none none",
      start: "top 5%",
      end: "bottom 50%",
      trigger: ".ly_workDetails",
      pin: true,
      anticipatePin: 1,
      onLeaveBack: () => $(".pin-spacer").removeClass("scroll"),
      onLeave: () => $(".ly_workDetails__wrap,.pin-spacer").addClass("scroll"),
      onEnterBack: () => $(".ly_workDetails__wrap").removeClass("scroll"),
    },
  });
  tl5.scrollTrigger.refresh();
  }
});*/

  const tl6 = gsap.to(".ly_workDetails__wrap-how", {
    scrollTrigger: {
      toggleActions: "none play none none",
      start: "top 500px",
      end: "bottom 100%",
      trigger: ".ly_workDetails__wrap-how",
      onLeaveBack: () => $(".ly_workDetails__wrap-flow").removeClass("scroll"),
      onLeave: () => $(".ly_workDetails__wrap-flow").addClass("scroll"),
      onEnterBack: () => $(".ly_workDetails__wrap-flow").removeClass("scroll"),
    },
  });
  tl6.scrollTrigger.refresh();

};

const keyName = "visited";
const keyValue = true;

if (!sessionStorage.getItem(keyName)) {
  sessionStorage.setItem(keyName, keyValue);

window.addEventListener("load", function () {
  const targetMV = document.querySelector(".ly_mv");
  const targetHTML = document.querySelector("html");
  const openingTL = gsap.timeline({ delay: 0 });
  $(".ly_mv").addClass("loaded");
  openingTL
    .to(".ly_mv", { autoAlpha: 1, duration: 1 })
    .set("#mainvisual .mask", { autoAlpha: 1 }, "<")
    .fromTo(
      ".ly_mv__ttl",
      { y: "60%", ease: "power2.inOut", duration: 1.1 },
      { y: "0%", ease: "power2.inOut", duration: 1.1 },
    )
    .fromTo(
      ".el_ticker",
      { autoAlpha: 0, y: "30%", ease: "power2.inOut", duration: 0.9 },
      { autoAlpha: 1, y: "0%", ease: "power2.inOut", duration: 0.9 },
      2
    )
    .fromTo(
      ".ly_header",
      { autoAlpha: 0, y: "30%", ease: "power2.inOut", duration: 0.9 },
      { autoAlpha: 1, y: "0%", ease: "power2.inOut", duration: 0.9 },
      2
    )
    .fromTo(
      ".js_slide",
      { autoAlpha: 0, y: "5%", ease: "power2.inOut", duration: 0.9 },
      { autoAlpha: 1, y: "0%", ease: "power2.inOut", duration: 0.9 },
      2
    )
    .add(() => {
      targetMV.classList.add("is-active");
    })
    .add(() => {
      targetHTML.classList.add("is-active");
    });
});
} else {
  $(".ly_mv").addClass("loaded");
  $("html").addClass("loaded");
  $('html').addClass('is-active');
  $(".ly_mv").addClass("is-active");
}

$(window).scroll(function () {
  if ($(window).scrollTop() > 1) {
    $(".ly_header").addClass("fixed");
  } else {
    $(".ly_header").removeClass("fixed");
  }
});

gsap.set(".js_fadein", {
  autoAlpha: 0,
  y: 100,
  duration: 1,
  ease: "power1.out",
});

ScrollTrigger.batch(".js_fadein", {
  onEnter: (batch) =>
    gsap.to(batch, {
      autoAlpha: 1,
      y: 0,
      duration: 1,
      stagger: 0.2,
      overwrite: true,
      ease: "power1.out",
    }),
  start: "top 90%",
});

$(function () {
  $(".js_slide").slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 15000,
    cssEase: "linear",
    slidesToShow: 2,
    swipe: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1.2,
        },
      },
    ],
  });
});

$(".ly_header__toggle").click(function () {
  $(this).toggleClass("open");
  $(".ly_header").toggleClass("open");
});

$(".ly_qa .ly_qa__main dl dt").click(function () {
  $(this).next().slideToggle();
  console.log('click');
});

const flyA = (targetA) => {
  const startTime = performance.now();
  const amplitude = { x: -10, y: 10, rotation: 1 };
  const speed = { x: 0.001, y: 0.001 };
  const tick = () => {
    const diff = performance.now() - startTime;
    const x = amplitude.x * Math.sin(speed.x * diff);
    const y = amplitude.y * Math.sin(speed.y * diff);
    const rotation = amplitude.rotation * (1 + Math.sin(speed.y * diff));
    targetA.style.transform = `rotate(${rotation}deg) translate(${x}%, ${y}%)`;
    requestAnimationFrame(tick);
  };
  tick();
};
const targetA = document.querySelectorAll(".js_targetA");
for (let i = 0; i < targetA.length; i++) {
  flyA(targetA[i]);
}

const imageA = document.querySelectorAll(".js_rotateA");
  for (let i = 0; i < imageA.length; i++) {
    imageA[i].animate(
      [{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }],
        {
          fill: "backwards",
          duration: 20000,
          iterations: Infinity,
        }
    );
  }

const flyB = (targetB) => {
  const startTime = performance.now();
  const amplitude = { x: 10, y: -10, rotation: 1 };
  const speed = { x: 0.001, y: 0.001 };
  const tick = () => {
    const diff = performance.now() - startTime;
    const x = amplitude.x * Math.sin(speed.x * diff);
    const y = amplitude.y * Math.sin(speed.y * diff);
    const rotation = amplitude.rotation * (1 + Math.sin(speed.y * diff));
    targetB.style.transform = `rotate(${rotation}deg) translate(${x}%, ${y}%)`;
    requestAnimationFrame(tick);
  };
  tick();
};
const targetB = document.querySelectorAll(".js_targetB");
for (let i = 0; i < targetB.length; i++) {
  flyB(targetB[i]);
}

const imageB = document.querySelectorAll(".js_rotateB");
for (let i = 0; i < imageB.length; i++) {
  imageB[i].animate(
    [{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }],
    {
      fill: "backwards",
      duration: 20000,
      iterations: Infinity,
    }
  );
}

const flyC = (targetC) => {
  const startTime = performance.now();
  const amplitude = { x: 10, y: -10, rotation: 1 };
  const speed = { x: 0.001, y: 0.001 };
  const tick = () => {
    const diff = performance.now() - startTime;
    const x = amplitude.x * Math.sin(speed.x * diff);
    const y = amplitude.y * Math.sin(speed.y * diff);
    const rotation = amplitude.rotation * (1 + Math.sin(speed.y * diff));
    targetC.style.transform = `rotate(${rotation}deg) translate(${x}%, ${y}%)`;
    requestAnimationFrame(tick);
  };
  tick();
};
const targetC = document.querySelectorAll(".js_targetC");
for (let i = 0; i < targetC.length; i++) {
  flyC(targetC[i]);
}

const imageC = document.querySelectorAll(".js_rotateC");
for (let i = 0; i < imageC.length; i++) {
  imageC[i].animate(
    [{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }],
    {
      fill: "backwards",
      duration: 50000,
      iterations: Infinity,
    }
  );
}


$(".js_btn01").click(function () {
  $("html").animate(
    {
      scrollTop: $("html").scrollTop() - 100,
    },
    300);
});
$(".js_btn02").click(function () {
  $("html").animate(
    {
      scrollTop: $("html").scrollTop() + 100,
    },
    300
  );
});

window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      e.preventDefault();
      const target = document.querySelector(anchor.hash);
      const targetOffsetTop =
        window.scrollY + target.getBoundingClientRect().top;

      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth",
      });
    });
  });
});
